import { sprintf } from 'sprintf-js';

import { FilestackImageData } from 'api/types/shared.types';
import { Box } from 'components/Box';
import { FilestackImage } from 'components/Image';
import { ConditionalLink } from 'components/Link';
import { Body } from 'components/Text/Body';
import { H4 } from 'components/Text/H4';
import { Text } from 'components/Text/Text';
import { colors } from 'theme';
import { humanDateTime } from 'utils/date';

type Props = {
  slug?: string;
  name?: string;
  image?: FilestackImageData;
  homePageUrl?: string;
  postedDate: string;
  showDate: boolean;
  small?: boolean;
};

export function Byline({
  slug,
  name,
  image,
  homePageUrl,
  postedDate,
  showDate,
  small,
}: Props) {
  return (
    <Box classes={['flex', 'align-center']} data-qa-id="byline" flex="2">
      {image && (
        <Box mr={3}>
          <FilestackImage
            data-qa-id="byline-image"
            alt={sprintf(getText('%(name)s profile image'), {
              name,
            })}
            data={image}
            width={60}
            height={60}
            round
          />
        </Box>
      )}
      <Box>
        {name && (
          <H4 data-qa-id="author-name" m={0} lineHeight={1}>
            <ConditionalLink
              data-qa-id="author-name-link"
              link={
                homePageUrl && slug
                  ? `/${homePageUrl}?author.slug=${slug}&pq=`
                  : ''
              }
            >
              <Body
                // @ts-expect-error TS(2322): Type 'false | "bodySmall" | undefined' is not assi... Remove this comment to see the full error message
                styleAs={small && 'bodySmall'}
                lineHeight={1.33}
              >
                {name}
              </Body>
            </ConditionalLink>
          </H4>
        )}
        {showDate && (
          <Text
            tag="time"
            // @ts-expect-error TS(2769): No overload matches this call.
            dateTime={postedDate}
            color={colors.lightContentGrey}
            styleAs={small ? 'bodyMicro' : 'bodySmall'}
          >
            {humanDateTime(postedDate)}
          </Text>
        )}
      </Box>
    </Box>
  );
}
